/**
 * Rosetta site config.
 *
 * Local dev: defaults to wrangler at 127.0.0.1:8787.
 * Production: set via VITE_API_BASE (see site/.env.production or Pages env vars).
 */
export const API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE) ||
  "http://127.0.0.1:8787";

export const LANGUAGES = [
  { code: "fr", label: "FR", native: "Français" },
  { code: "es", label: "ES", native: "Español" },
  { code: "pa", label: "ਪੰ", native: "ਪੰਜਾਬੀ" },
  { code: "hi", label: "हि", native: "हिन्दी" },
  { code: "ja", label: "日", native: "日本語" },
];

export const SECTORS = [
  { code: "world", label: "World" },
  { code: "business", label: "Business" },
  { code: "tech", label: "Tech" },
  { code: "culture", label: "Culture" },
  { code: "science", label: "Science" },
  { code: "sport", label: "Sport" },
];

export const LANG_BCP47 = {
  fr: "fr",
  es: "es",
  pa: "pa",
  hi: "hi",
  ja: "ja",
};
